import { HttpClientPort } from '../../../core/domain/ports/HttpClientPort';
import { AnimaliaDetailRepositoryPort } from '../domain/ports/AnimaliaDetailRepositoryPort';
import { AnimaliaListRepositoryPort } from '../domain/ports/AnimaliaListRepositoryPort';
import { AnimaliaSearchRepositoryPort } from '../domain/ports/AnimaliaSearchRepositoryPort';
import { AnimaliaDetailApiRepositoryAdapter } from '../infrastructure/adapters/AnimaliaDetailApiRepositoryAdapter';
import { AnimaliaListApiRepositoryAdapter } from '../infrastructure/adapters/AnimaliaListApiRepositoryAdapter';
import { AnimaliaSearchApiRepositoryAdapter } from '../infrastructure/adapters/AnimaliaSearchApiRepositoryAdapter';
import { FetchAnimaliaDetailUseCase } from './use-cases/FetchAnimaliaDetailUseCase';
import { FetchAnimaliaListingUseCase } from './use-cases/FetchAnimaliaListingUseCase';
import { SearchAnimaliaUseCase } from './use-cases/SearchAnimaliaUseCase';

export interface AnimaliaUseCases {
  fetchAnimaliaListing: FetchAnimaliaListingUseCase;
  fetchAnimaliaDetail: FetchAnimaliaDetailUseCase;
  searchAnimalia: SearchAnimaliaUseCase;
}

export function animaliaUseCasesFactory(httpClient: HttpClientPort): AnimaliaUseCases {
  const listRepository: AnimaliaListRepositoryPort = new AnimaliaListApiRepositoryAdapter(httpClient);
  const detailRepository: AnimaliaDetailRepositoryPort = new AnimaliaDetailApiRepositoryAdapter(httpClient);
  const searchRepository: AnimaliaSearchRepositoryPort = new AnimaliaSearchApiRepositoryAdapter(httpClient);

  return {
    fetchAnimaliaListing: new FetchAnimaliaListingUseCase(listRepository),
    fetchAnimaliaDetail: new FetchAnimaliaDetailUseCase(detailRepository),
    searchAnimalia: new SearchAnimaliaUseCase(searchRepository),
  };
}
